import { useNavigate } from "react-router-dom";
import AppMenu from "../components/layout/AppMenu";
import { useLanguage } from "../context/Language/LanguageContext";
import Settings from "./Settings";

// Standalone /settings route so Settings is reachable from AppMenu's
// slide-out drawer on pages that don't have MainPage's own sidebar.
function SettingsPage() {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="mt-2">
      <div className="mb-2 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <AppMenu current="/settings" />
          <h2 className="text-lg font-semibold">{t("Settings")}</h2>
        </div>
        <button className="btn btn-sm btn-ghost" onClick={() => navigate(-1)}>
          {t("Back")}
        </button>
      </div>
      <Settings onSettingsChange={() => {}} />
    </div>
  );
}

export default SettingsPage;
